import $ from 'jquery';

export default function vimeoRefreshForVimeoPopups() {
    $('.video-popup[href^="https://vimeo.com"]').on('mfpOpen', function() {
        if (typeof window.__vimeoRefresh === 'function') {
            setTimeout(function() {
                window.__vimeoRefresh();
            }, 3000);
        }
    });
}
